// import APIPATH from "../common";
// const apiCall = async (endpoint, payload) => {
//     const config = APIPATH[endpoint];
//     let url = config.url;

//     const options = {
//         method: config.method,
//         credentials: 'include',
//         headers: { "content-type": "application/json" },
//     };

//     if (payload !== undefined) {
//         if (config.method === 'GET') {
//             // Convert JSON payload to ?key=value&key2=value2 string
//             const queryString = new URLSearchParams(payload).toString();
//             url = `${url}?${queryString}`;
//         } else {
//             // Only attach body if method is POST/PUT/PATCH
//             options.body = JSON.stringify(payload);
//         }
//     }

//     const httpResponse = await fetch(url, options);
//     return httpResponse.json();
// };

// export default apiCall;

import APIPATH from "../common";

const apiCall = async (endpoint, payload) => {
    const config = APIPATH[endpoint];
    if (!config) throw new Error(`Endpoint "${endpoint}" not found`);

    let url = config.url;
    // Work with a copy to avoid side effects
    let currentPayload = payload ? { ...payload } : {};

    // 1. URL Parameter Replacement (e.g., /api/:slug -> /api/my-saree)
    Object.keys(currentPayload).forEach(key => {
        const placeholder = `:${key}`;
        if (url.includes(placeholder)) {
            url = url.replace(placeholder, currentPayload[key]);
            // IMPORTANT: Remove it so it doesn't get added to the body or query string
            delete currentPayload[key];
        }
    });

    const options = {
        method: config.method.toUpperCase(),
        credentials: 'include',
        headers: { "content-type": "application/json" },
    };

    // 2. Handle remaining data
    const hasData = Object.keys(currentPayload).length > 0;
    
    if (options.method === 'GET') {
        if (hasData) {
            const queryString = new URLSearchParams(currentPayload).toString();
            url = `${url}?${queryString}`;
        }
        // NEVER attach a body to a GET request
    } else if (hasData) {
        options.body = JSON.stringify(currentPayload);
    }

    const httpResponse = await fetch(url, options);
    return httpResponse.json();
};

export default apiCall;